module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre9"
  }, [_vm._v("Dramatis personae")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('table', {
    staticClass: "true",
    attrs: {
      "cellpadding": "5",
      "cellspacing": "0",
      "summary": "Personen"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Sabine Ruschewey,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nAdelheid Ruschewey,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nAgathe Ruschewey,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nLudowike Ruschewey")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre7"
  }, [_vm._v("vier Schwestern im Alter von 25, 22, 20 und 15\nJahren, Töchter des verstorbenen Kaufmanns Bertold Ruschewey")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Gustav Ruschewey,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nEmilie Ruschewey")])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre7"
  }, [_vm._v("Geschwister des Bertold Ruschewey; Gustav ist 68,\nEmilie 60 Jahre alt")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Oberlehrer Dr.\nNast")]), _vm._v(",")]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre7"
  }, [_vm._v("Pflegesohn Tante Emiliens, 37 Jahre alt")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Frau Madelon von\nHeyder")]), _vm._v(",")]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre7"
  }, [_vm._v("Großmama der Schwestern Ruschewey")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Reinhold Kranz")]), _vm._v(",")]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre7"
  }, [_vm._v("Adelheids Bräutigam, Kaufmann, 27 Jahre alt")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Otto Kranz")]), _vm._v(",")]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre7"
  }, [_vm._v("sein Bruder, 17jährig, besucht die Kunstakademie\nin München")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Dr. Grünwald")]), _vm._v(",")]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre7"
  }, [_vm._v("Arzt, 34 Jahre alt")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Dr. Kozakiewicz")]), _vm._v(",")]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre7"
  }, [_vm._v("Bibliothekar, 36 Jahre alt, leidend")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Konsistorialrat\nJoël")]), _vm._v(",")]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }), _vm._v(" "), _c('td', {
    staticClass: "calibre7"
  }, [_vm._v("70 Jahre alt")])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Ein Vagabund")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Ein Herr")])])])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("Die vier Schwestern Ruschewey sind\nübereinstimmend gekleidet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("Die Zeit der Geschehnisse ist die zweite Hälfte\ndes vorigen Jahrhunderts.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0